module.exports = __webpack_public_path__ + "assets/b49.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b49.png
// module id = 637
// module chunks = 0